<template>
    <div>
        <div v-if="okLoad" class="Group-product-details">
            <div class="product-details">
                <product-details 
                    :artworks="artworks" 
                    :mockups="mockups" 
                    :originProduct="originProduct" 
                    :personalized="personalized"
                    :platform="platform"
                    :variants="variants"
                    :permalink="permalink"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { APP_API} from '../../config'
import ProductDetails from './ProductDetails';
import { get } from 'lodash'
import {treeToArray, loadCampaign} from '../../helper/helper'
import url from 'url'
export default {
  components: { ProductDetails },
    name: "Product",
    props:{
        id: {
            type: String,
            required: true
        },
        origin_id: {
            type: String,
            required: true
        }
    },
    data(){
        return {
            title: '',
            permalink: '',
            image: '',
            artworks: [],
            mockups: [],
            originProduct: {},
            okLoad: false,
            personalized: {},
            price_html: '',
            platform: '',
            variants: {}
        }
    },
    computed: {
        ...mapGetters['store']
    },
    async mounted(){
        const site = this.$store.state.siteURL;
        var data
        await loadCampaign(site, this.origin_id)
        .then(datas => {
            data = datas.campaign
        })
        .catch(err => console.log(err))

        this.$emit('OffLoding', false)

        if(typeof data == 'object'){
            const originProduct = data.originProduct;
            if(data.platform == "woocommerce"){
                this.title = originProduct.name;
                this.permalink = originProduct.permalink;
                this.image = originProduct.images[0]['src'];
                this.price_html = originProduct.price_html;
            }
            if(data.platform == "shopify"){
                this.title = originProduct.product.title;
                this.image = originProduct.product.image.src;
            }
            
            this.artworks = data.artworks;
            this.mockups = data.mockups;
            this.originProduct = data.originProduct;
            this.platform = data.platform;
            this.variants = data.variants;

            data.artworks.forEach(artwork => {
                var personalized = {}
                treeToArray(artwork.templates[0].layers)
                .filter(
                    layer =>
                    layer.type === 'Option' ||
                    (layer.personalized && layer.personalized.enable)
                )
                .forEach(layer => {
                    switch (layer.type) {
                    case 'Text':
                        personalized[layer.id] = (
                        layer.values.find(v => v.active) || layer.values[0]
                        ).text
                        break
                    case 'Image':
                        if (layer.personalized.type === 'clipartCategory') {
                        if (layer.personalized.default) {
                            personalized[layer.id] = layer.personalized.default.file
                        } else {
                            var defaultVal = layer.values.find(v => v.active)
                            if (!defaultVal) {
                            defaultVal = layer.values[0]
                            }
                            personalized[layer.id] = defaultVal.file
                        }
                        } else {
                        var defaultVal = layer.values.find(v => v.active)
                        if (!defaultVal) {
                            defaultVal = layer.values[0]
                        }
                        personalized[layer.id] = defaultVal.file
                        }
                        break
                    case 'Option':
                        var defaultVal = get(layer, 'options', []).find(op => op.default)
                        if (!defaultVal) {
                        personalized[layer.id] = get(layer, 'options[0].value')
                        } else {
                        personalized[layer.id] = defaultVal.value
                        }
                    default:
                        break
                    }
                });

                this.personalized = {
                    [artwork.id]: {
                    ...(personalized[artwork.id] || { template: 0 }),
                    ...personalized
                    }
                }
            })
            this.okLoad = true
        }
    }
}
</script>

<style scoped>
    .Group-product-details{
    }
    .product-details{
        width: 33.33%;
        float: left;
        padding: 0px 5px;
        position: relative;
        
    }

    @media (max-width: 767px) {
        .product-details{
            width: 50%;
            float: left;
            padding: 0px 5px;
            position: relative;
            margin-bottom: 10px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/BundledProduct/Product.vue